import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Contact = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow pt-32 pb-20 px-8 lg:px-16">
        <div className="max-w-[1200px] mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-wide mb-16">{t('contact.title')}</h1>

          <div className="space-y-12">
            <div className="border-b border-gray-200 pb-8">
              <h2 className="text-2xl font-light tracking-wide mb-4">{t('contact.agencyName')}</h2>
              <a href="https://www.smarch.fr" target="_blank" rel="noopener noreferrer"
                className="text-lg text-[#d94e47] hover:opacity-70 transition-opacity duration-300">
                {t('contact.website')}
              </a>
            </div>

            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h3 className="text-lg font-light tracking-wide mb-4 text-gray-700">{t('contact.headOffice')}</h3>
                <p className="text-base font-light leading-relaxed">5, rue Danton<br />93100 Montreuil</p>
              </div>
              <div>
                <h3 className="text-lg font-light tracking-wide mb-4 text-gray-700">{t('contact.office')}</h3>
                <p className="text-base font-light leading-relaxed">30, Allée Vivaldi<br />75012 PARIS</p>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-8">
              <div className="space-y-4">
                <p className="text-base font-light">
                  <span className="text-gray-700 mr-4">{t('contact.phone')}</span>
                  <a href="tel:+33617750880" className="hover:text-[#d94e47] transition-colors duration-300">06 17 75 08 80</a>
                </p>
                <p className="text-base font-light">
                  <span className="text-gray-700 mr-4">{t('contact.email')}</span>
                  <a href="mailto:candidatures@smarch.fr" data-testid="contact-email-link" className="hover:text-[#d94e47] transition-colors duration-300">candidatures@smarch.fr</a>
                </p>
                <p className="text-base font-light text-gray-700">
                  <span className="mr-4">{t('contact.siret')}</span>521 446 872 00017
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Contact;
